import styled, { css } from "styled-components"

import { MEDIA_SIZES } from "@assets/styles/mediaSizes"

export const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--transparentBlack);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  /* wave4-fix9: recolor the WHOLE create flow to Ale blue by scoping the app's pink token to
     this modal subtree -- every ButtonEl/accent that reads var(--radicalRed) goes blue here
     without touching the shared component or the rest of the app. */
  --radicalRed: #7fb1e3;
`

export const Wrapper = styled.div`
  ${({ $isMain }) => css`
    /* wave4-fix11: compact dialog per QJ -- was 615px x 95vh full-page sheet */
    /* wave4-fix18 (QJ): CENTERED POPUP DIALOG -- same presentation as the Suggest When popup
       (components/Modal: fixed flex-centered dimmed wrapper; dialog rounded + shadowed, both
       axes centered). Replaces the bottom-anchored mobile-sheet placement. The p0func ITEM4
       scroll containment below stays -- just re-housed in a centered container. */
    width: 500px;
    height: auto;
    max-height: 85vh;
    background-color: ${$isMain ? "#7FB1E3 /* wave4-fix9: Ale blue */" : "var(--white)"};
    border-radius: 16px;
    box-shadow: 0 14px 44px -8px rgba(20, 30, 60, 0.35);
    box-sizing: border-box;
    padding: 10px 18px 0 18px; /* wave4-fix11: tighter */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /* wave4-p0func ITEM4: the max-height above never actually CONTAINED the content -- with
       height:auto and no overflow, the inner .create-teeup's "height: 100%" resolved against an
       auto-height parent (= falls back to content height, ~906px), so at any viewport under
       ~940px the body never scrolled and the footer (Create/Cancel) spilled clipped off-screen
       (reproduced at 1366x768 and 1152x720). Flex column + overflow hidden makes max-height a
       real bound; the .create-teeup child then flexes into the remaining space and its own
       overflow-y:auto finally engages (its sticky-bottom Buttons wrapper pins the Create button
       visible while the body scrolls). */
    display: flex;
    flex-direction: column;
    overflow: hidden;

    @media (max-width: ${MEDIA_SIZES.TABLET_L}) {
      width: 97%;
      height: 97%;
    }

    @media (max-width: ${MEDIA_SIZES.MOBILE}) {
      width: 100%;
      height: 100%;
      max-height: 100%;
      border-radius: 0;
      padding: 0;
      top: 0;
      transform: translateX(-50%); /* full-sheet on mobile, anchored top */
    }
    @media (min-height: 900px) {
      height: auto; /* wave4-fix11: compact dialog, size to content */
    }
  `};
`
